import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export default {
    install: (Vue, pluginConfig) => {
        Vue.prototype.$CookieConsent = CookieConsent;
        CookieConsent.run(pluginConfig);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Controlla se CookieConsent è disponibile e se ha un metodo per ottenere lo stato
    if (typeof CookieConsent !== 'undefined' && CookieConsent.getUserPreferences) {
        const userPreferences = CookieConsent.getUserPreferences();
        console.log('Preferenze utente all\'avvio:', userPreferences);

        // userPreferences.acceptedCategories contiene le categorie accettate
        if (userPreferences && userPreferences.acceptedCategories && userPreferences.acceptedCategories.includes('marketing')) {
            //initializeMetaPixel();
        }
    } else {
        console.warn('Libreria CookieConsent non disponibile o metodo getUserPreferences non trovato all\'avvio.');
    }
});